export default "__VITE_ASSET__BDHJ6CEx__"